import { daoPut } from 'mrf/Dao';
import { TYPE_GET_LIST, useFetcherSelector, useFormFullSelector, useFormSelector } from 'mrf/redux/ReduxHelper';
import { FormContext } from 'mrf/view/FormCRUD';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ConfirmationModal from 'mrf/view/ConfirmationModal';
import PropTypes from 'prop-types';
import QueryObjectField from 'mrf/view/QueryObjectField';

export default function UserCountry({ userId }) {
    const { t } = useTranslation();
    const user = useSelector(state => state?.resources?.users?.byId?.[userId]);
    const context = useFormSelector({ resource: 'userCountryForm' });
    const { data, set } = useFormFullSelector(context);
    
    const country = useFetcherSelector({
        selector: state => state?.resources?.countries?.byId?.[data?.countryId],
        type: TYPE_GET_LIST,
        resource: 'countries',
        endpoint: `/api/countries`,
        condition: () => true,
    });

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pendingCountryId, setPendingCountryId] = useState(null);

    useEffect(() => {
        set({ countryId: user?.countryId });
    }, [country, user, user?.countryId]); // eslint-disable-line

    useEffect(() => {
        if (!data?.countryId || data.countryId === user?.countryId) {
            return;
        }
        setPendingCountryId(data.countryId);
        setIsModalOpen(true);
    }, [data?.countryId]); // eslint-disable-line

    const handleConfirm = () => {
        setIsModalOpen(false);

        daoPut(`/api/users/${userId}/country`, { countryId: pendingCountryId });
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        set({ countryId: user?.countryId });
    };

    const countryFields = [
        { name: 'Name', key: 'name' },
        { name: 'Code', key: 'abbreviation' },
    ];

    return (
        <FormContext.Provider value={context}>
            <QueryObjectField
                label={t('Country')}
                resource='countries'
                endpoint={'/api/countries'}
                displayAttribute='name'
                field='countryId'
                fields={countryFields}
                disableRemove
                disableAdd
                required
            />
            <ConfirmationModal
                isOpen={isModalOpen}
                onCancel={handleCancel}
                onConfirm={handleConfirm}
                title={t('Confirm Save')}
                message={t("Do you really want to change country to {{country}}?", {country: country?.name || ''})}
            />
        </FormContext.Provider>
    );
}

UserCountry.propTypes = {
    userId: PropTypes.string.isRequired,
};